import Vue from 'vue';
import { MainPageMap } from '@/components/Map';

export function createMainPageMapWidget(
    el: HTMLElement,
    settings: unknown,
    modalData: unknown
) {
    return new Vue({
        el: el!,
        data: {
            rootProps: { settings, modalData },
        },
        render: (h) => h(MainPageMap),
    });
}
